import { cache } from 'react';
import { Product } from '../types/Header';
import { proxifyDictionaryImages } from './proxifyImageUrl';

export const fetchProducts = cache(async (page?: number, searchQuery?: string, url?: string): Promise<{ products: Product[], totalPages: number }> => {
  try {
    const fetchAllProducts = !page && !searchQuery;
    const response = fetchAllProducts
      ? await fetch(`${url ?? ''}/api/products`)
      : await fetch(`${url ?? ''}/api/products?page=${page}&query=${encodeURIComponent(searchQuery ?? '')}`);

    if (!response.ok) {
      throw new Error('Failed to fetch products');
    }
    const res = await response.json();
    return proxifyDictionaryImages(res)
  } catch (error) {
    console.error(error);
    return { products: [], totalPages: 0 };
  }
})
